import repository from '@/services/repository';

const resource = '/quotationconditions';

export default {
    get() {
        return repository.get(`${resource}`);
    },
    getSingle(id: string) {
        return repository.get(`${resource}/${id}`);
    },
    create(payload: any) {
        return repository.post(`${resource}`, payload);
    },
    update(payload: any) {
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return repository.delete(`${resource}/${payload.id}`);
    },
};
